import Vue from 'vue'
import Vuex from 'vuex'
import webApi from '../webApi'
import { SearchContactModel } from '../webApi/DataModels'
import constants from '../constants'

// Vuex
Vue.use(<any>Vuex)

export default {
  namespaced: true,
  state: {
    loading: false,
    contacts: []
  },
  mutations: {
    resetContacts ({ contacts }) {
      contacts = []
    },
    setContacts (state, list) {
      state.contacts = list
    },
    loadingState ({ loading }, isLoading) {
      loading = isLoading
    }
  },
  actions: {
    reset ({ commit }) {
      commit('resetContacts')
    },
    getContacts ({ commit, dispatch }, { customerID, countryID }) {
      return dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.CONTACT, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
        .then((hasPermission):any => {
          if (!hasPermission) {
            return Promise.resolve('not needed')
          } else {
            var contactSearchModel:SearchContactModel = {
              Customer_ID: customerID,
              Country_ID: countryID
            } as SearchContactModel
            // the list has not been stored in session yet, load from server
            webApi.contact.get_Contact_List(contactSearchModel)
              .then((response) => {
              // Convert the loaded list into JSON object list
                var loadedList = response.data as any
                var contacts = []
                if (loadedList != null) {
                  for (var i = 0; i < loadedList.length; i++) {
                  // convert the loaded row into a option which can be used in a checkbox list/drop down etc.
                    var label = loadedList[i].Contact_Name != null ? loadedList[i].Contact_Name : ''
                    if (label && label.length > 0) {
                      label += ' (' + loadedList[i].Phone_Number + ')'
                    } else {
                      label = loadedList[i].Phone_Number
                    }

                    var option = {
                      value: loadedList[i].Contact_ID,
                      label: label,
                      selected: false,
                      contactItem: loadedList[i]
                    }
                    // Add option to list
                    contacts.push(option)
                  }
                }
                commit('setContacts', contacts)
                commit('loadingState', { isLoading: false })
              }).catch((response) => {
                commit('loadingState', { isLoading: false })
                window.bus.$emit('openErrorModal', 'Error loading contacts: ' + response.data.ExceptionMessage)
              })
          }
        })
    }
  },
  getters: {
    contacts: (state) => {
      return state.contacts
    }
  }
}
